import { Injectable }              from '@angular/core';
import { JWTService }              from '@omnilib/services/jwt.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError }         from 'rxjs/operators';
import { Observable, of, throwError}        from 'rxjs';
import { environment }             from '@omnienv/omnicms/devcms/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  headers:      HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  jwtstring:    string = '';
  responsetype: string = 'json';

  error = { "result": { "code": "-1", "message": "Server Error", "resultset": null } };

  constructor( public  http: HttpClient
             , public  jwt:  JWTService
             ) {
  }

  getjwt() {
    if ( this.jwtstring == '' ) {
      this.jwtstring = this.jwt.get();
    }
    return this.jwtstring;
  }

  setjwt(jwtstring: string = ''): Observable<string> {
    if (jwtstring !== '') {
      this.jwt.set(jwtstring);
      this.jwtstring = jwtstring;
    }
    return of(jwtstring); // or return of(void 0) if you don't need to emit the string
  }

  clearjwt() {
    this.jwt.clear();
    this.jwtstring = '';
  }

  callApi<T>(method: string, name: string, params?: any): Observable<T> {
    let url = environment.production ? environment.apiurl + name : 'rest/' + name;

    if (environment['acc']) {
      url = environment.apiurl + name;
    }

    // Set headers
    if (['operations/readTranslations/', 'auth/sso', 'auth/authenticate', 'auth/reset-password', 'auth/2fa'].includes(name) || name.includes('auth/verify-reset')) {
      this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    } else {
      this.jwtstring = this.getjwt();
      if (!this.jwtstring) return throwError(() => new Error('JWT not found'));
      this.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + this.jwtstring,
      });
    }

    switch (method) {
      case 'get':
        return this.http.get<T>(url, { headers: this.headers }).pipe(catchError(this.handleError));
      case 'post':
        return this.http.post<T>(url, params, { headers: this.headers }).pipe(catchError(this.handleError));
      case 'put':
        return this.http.put<T>(url, params, { headers: this.headers }).pipe(catchError(this.handleError));
      case 'delete':
        return this.http.delete<T>(url, { headers: this.headers }).pipe(catchError(this.handleError));
      default:
        return throwError(() => new Error('Invalid method'));
    }
  }
  callapi( what, name, params ) {
    if ( name == 'operations/readTranslations/' || name == 'auth/sso' || name == 'auth/authenticate' || name == 'auth/reset-password' || name == 'auth/2fa' || name.indexOf('auth/verify-reset') != -1 ) {
      this.headers      = new HttpHeaders({ 'Content-Type': 'application/json' });
    } else {
      this.jwtstring = this.getjwt();

      if ( this.jwtstring == '' ) {
        this.error;
      } else {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json'
                                       , 'Access-Control-Allow-Origin': '*'
                                       , 'Authorization' : 'Bearer '+ this.jwtstring
                                       });
      }
    }

    let url = ( environment.production ? environment.apiurl : 'rest/' ) + name;

    if(environment['acc']) {
      url = environment.apiurl + name;
    }

    switch (what) {
      case 'get':
        return this.get(url);
        break;
      case 'put':
        return this.put(url, params);
        break;
      case 'delete':
        return this.delete(url);
        break;
      case 'post':
      default:
        //return this.post(url, params).pipe(map((data) => data));
        return this.post(url,params, name == 'soap');
        break;
    }
  }

  async get(url) {
    try {
      return await this.http.get( url, { headers: this.headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      console.log (e);
      return this.error;
    }
  }
  private handleError(error: any) {
    console.error(error);
    return throwError(() => error);
  }

  /*
  async getpc( postcode, housenumber ) {
    let url: string = '';
    let headers: HttpHeaders;

    if ( environment['config']['postcode'] != undefined && environment['config']['postcode']['url'] != undefined ) {
      console.log( 'am i getting here?' );
      url     = ( environment.production ? environment['config']['postcode']['url'] : 'pc/' ) + postcode + '/' + housenumber;
      headers = new HttpHeaders( { 'Authorization' : 'Basic '+ btoa(environment['config']['postcode']['key'] + ':' + environment['config']['postcode']['secret']) } );
    } else {
      console.log( 'or am i getting here?' );
      url = environment["apiurl"] + "lib/postal-check/" + postcode + '/' + housenumber;
      headers = this.headers;
    }

    console.log(url);
    console.log(headers);

    try {
      return await this.http.get( url, { headers: headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      return null;
    }
  }
  */

  async getpc( postcode, housenumber ) {
    let url = ( environment.production ? environment.apiurl : 'rest/' ) + 'pc/' + postcode + '/' + housenumber;

    this.headers = new HttpHeaders({ 'Content-Type': 'application/json'
                                   , 'Access-Control-Allow-Origin': '*'
                                   , 'Authorization' : 'Bearer '+ this.jwtstring
                                   });

    try {
      return await this.http.get( url, { headers: this.headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      return null;
    }
  }

  async getcountries() {
    let url = ( environment.production ? environment['config']['countries']['url'] : 'countries' );

    if(environment['acc']) {
      url = environment['config']['countries']['url'];
    }

    let headers: HttpHeaders = new HttpHeaders( { 'Authorization' : 'Bearer '+ environment['config']['countries']['key'], 'Access-Control-Allow-Origin': '*' } );

    try {
      return await this.http.get( url, { headers: headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      return null;
    }
  }

  getnopromise(name, params ): Observable<any> {
    let url = ( environment.production ? environment.apiurl : 'rest/' ) + name;

    this.jwtstring = this.getjwt();

    this.headers = new HttpHeaders({ 'Content-Type': 'application/json'
                                   , 'Access-Control-Allow-Origin': '*'
                                   , 'Authorization' : 'Bearer '+ this.jwtstring
                                   });
    return this.http.post( url, params, { headers: this.headers, responseType: 'json' } );
  }

  getnopromise2(name): Observable<any> {
    let url = ( environment.production ? environment.apiurl : 'rest/' ) + name;

    this.headers = new HttpHeaders({ 'Content-Type': 'application/json'
                                   , 'Access-Control-Allow-Origin': '*'
                                   });
    return this.http.get( url, { headers: this.headers, responseType: 'json' } );
  }

  async post(url, params, soap = false) {
    this.headers.set('Access-Control-Allow-Origin', '*');

    try {
      if ( soap ) {
        return await this.http.post( url, { content: params }, { headers: this.headers, responseType: 'text' } ).toPromise();
      } else {
        return await this.http.post( url, params, { headers: this.headers, responseType: 'json' } ).toPromise();
      }
    } catch(e) {
      return this.error;
    }
  }

  async put(url, params) {
    try {
      return await this.http.put( url, params, { headers: this.headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      return this.error;
    }
  }

  async delete(url) {
    try {
      return await this.http.delete( url, { headers: this.headers, responseType: 'json' } ).toPromise();
    } catch(e) {
      return this.error;
    }
  }
}
